import { FC } from "react";
import UserUpgradeProgress from "@via/pages/authentication/user-upgrade/user-upgrade-progress.tsx";

interface UserUpgradeProps {
  onClose: () => void;
}

const UserUpgrade: FC<UserUpgradeProps> = ({ onClose }) => {
  return <UserUpgradeProgress onClose={onClose} />;
};

export default UserUpgrade;
